import { AbstractControl } from '@angular/forms';
import { GenericAccountValidator } from './generic-account-validator';

export class Trc20Bep20AddressAccountValidator extends GenericAccountValidator {
    protected static errors: any = {
        'es-AR': {
            bad_email:
                'Dirección incorrecta, debe ser por ejemplo: 0xb4499Ad2933FA97f7c153752FeF6FCE2f7c3FE4f para BSC o TNDzfERDpxLDS2w1q6yaFC7pzqaSQ3Bg3r para Tron'
        },
        'en-US': {
            bad_email:
                'Incorrect adress, here`s an example: 0xb4499Ad2933FA97f7c153752FeF6FCE2f7c3FE4f for BSC or TNDzfERDpxLDS2w1q6yaFC7pzqaSQ3Bg3r for Tron'
        }
    };
    protected static label: any = {
        'es-AR': 'Dirección BEP20 (BSC) o TRC20 (Tron)',
        'en-US': 'BEP20 (BSC) or TRC20 (Tron) Adress'
    };
    protected static placeholder: any = {
        'es-AR': '0xb4499Ad2933FA97f7c153752FeF6FCE2f7c3FE4f (BSC) o TNDzfERDpxLDS2w1q6yaFC7pzqaSQ3Bg3r (Tron)',
        'en-US': '0xb4499Ad2933FA97f7c153752FeF6FCE2f7c3FE4f (BSC) or TNDzfERDpxLDS2w1q6yaFC7pzqaSQ3Bg3r (Tron)'
    };
    public getLabelToAccountType(): string {
        return (
            Trc20Bep20AddressAccountValidator.label[Trc20Bep20AddressAccountValidator.lang] ??
            Trc20Bep20AddressAccountValidator.label['es-AR']
        );
    }

    public getPlaceholderToAccountType(): string {
        return (
            Trc20Bep20AddressAccountValidator.placeholder[Trc20Bep20AddressAccountValidator.lang] ??
            Trc20Bep20AddressAccountValidator.placeholder['es-AR']
        );
    }

    public accountValidate(control: AbstractControl): { [key: string]: any } | null {
        let error: any =
            Trc20Bep20AddressAccountValidator.errors[Trc20Bep20AddressAccountValidator.lang] ??
            Trc20Bep20AddressAccountValidator.errors['es-AR'];
        if (/^T[a-zA-Z0-9]{33}$/.test(control.value)) {
            return null;
        }
        if (/^0x[a-fA-F0-9]{40}$/.test(control.value)) {
            return null;
        }

        return {
            forbiddenName: error.bad_email
        };
    }
}
